var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMediosMultimedia = function SvgMediosMultimedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.422 16.715 5.671-4a.874.874 0 0 0 .002-1.43h-.001l-5.671-4h-.002a.856.856 0 0 0-.903-.051.873.873 0 0 0-.452.766v8c0 .312.167.61.451.766a.853.853 0 0 0 .905-.051ZM4.605 12c0-4.097 3.217-7.395 7.128-7.395S18.861 7.903 18.861 12c0 4.097-3.217 7.395-7.128 7.395-3.91 0-7.128-3.298-7.128-7.395Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.21
  })));
};
export default SvgMediosMultimedia;